import React from 'react';
import { API_BASE, apiHeaders, leseFallback } from '../../lib/api';
import { LdSheet } from '../../components/ui/LdSheet';

export function AuditModal({ schuelerId, onClose }: { schuelerId: number; onClose: () => void }) {
  const [eintraege, setEintraege] = React.useState<{
    id: number; entity_type: string; action: string; created_at: string;
    alt_wert: string | null; neu_wert: string | null;
    vorname: string | null; nachname: string | null;
  }[]>([]);
  const [laden, setLaden] = React.useState(true);

  React.useEffect(() => {
    fetch(`${API_BASE}/api/audit/schueler/${schuelerId}/verlauf`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/audit/schueler/:id/verlauf'))
      .then(d => { setEintraege(d); setLaden(false); })
      .catch(() => setLaden(false));
  }, [schuelerId]);

  const aktionLabel: Record<string, string> = { create: 'Angelegt', update: 'Geändert', delete: 'Gelöscht' };
  const typLabel: Record<string, string> = { note: 'Note', fehlzeit: 'Fehlzeit', schueler: 'Schüler' };

  return (
    // Welle Z3: K4-Rahmen (LdSheet), Inhalt unverändert
    <LdSheet open onClose={onClose} maxWidth={560} kopf={{ titel: 'Änderungsverlauf' }}>
        {laden ? (
          <div style={{ textAlign: 'center', padding: '24px 0', color: 'var(--ld-text-secondary)', fontSize: 13 }}>Lädt …</div>
        ) : eintraege.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '24px 0', color: 'var(--ld-text-secondary)', fontSize: 13 }}>Noch keine Einträge vorhanden.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {eintraege.map(e => (
              <div key={e.id} style={{ background: 'var(--ld-bg-input)', borderRadius: 'var(--ld-radius-md)', padding: '10px 14px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.2,
                    color: e.action === 'delete' ? 'var(--ld-danger-text)' : e.action === 'create' ? 'var(--ld-success)' : 'var(--ld-accent)' }}>
                    {aktionLabel[e.action] ?? e.action}
                  </span>
                  <span style={{ fontSize: 11, color: 'var(--ld-text-secondary)', marginLeft: 2 }}>{typLabel[e.entity_type] ?? e.entity_type}</span>
                  <span style={{ fontSize: 11, color: 'var(--ld-text-secondary)', marginLeft: 'auto' }}>
                    {e.vorname ? `${e.vorname} ${e.nachname}` : 'Unbekannt'} · {e.created_at.slice(0, 16).replace('T', ' ')}
                  </span>
                </div>
                {(e.alt_wert || e.neu_wert) && (
                  <div style={{ fontSize: 11, fontFamily: 'monospace', color: 'var(--ld-text-secondary)', wordBreak: 'break-all', marginTop: 2 }}>
                    {e.alt_wert && <div style={{ color: '#DC2626' }}>− {e.alt_wert.slice(0, 120)}</div>}
                    {e.neu_wert && <div style={{ color: 'var(--ld-success)' }}>+ {e.neu_wert.slice(0, 120)}</div>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
    </LdSheet>
  );
}